import { Button, Modal } from 'antd';
import PropTypes from "prop-types";
import { useEffect, useState } from 'react'
import axiosInstance from '../../../variables/api/axiosInstance';
import { toast } from 'react-toastify';

const TauxFractionnement = (props) => {
    const [rang, setRang] = useState(0);
    const [taux, setTaux] = useState(0);
    const [libelle, setLibelle] = useState("");
    const [editMode, setEditMode] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleAdd = () => {
        setLoading(true);
        const tf = {
            ...props.tauxFractionnement,
            rang: parseInt(rang),
            taux: parseFloat(taux),
            libelleTauxFractionnement: libelle,
            fractionnement: props?.fractionnement
        }
        if (editMode) {
            axiosInstance.put("/api/taux-fractionnement", tf)
                .then((res) => {
                    setIsModalOpen(false);
                    toast.success("Taux de fractionnement ajouté avec succès");
                    setLoading(false);
                })
                .catch((err) => {
                    console.error("Error adding taux fractionnement:", err);
                    toast.error("Erreur lors de l'ajout");
                    setLoading(false);
                });
        } else {
            axiosInstance.post("/api/taux-fractionnement", tf)
                .then((res) => {
                    setIsModalOpen(false);
                    toast.success("Taux de fractionnement ajouté avec succès");
                    setLoading(false);
                })
                .catch((err) => {
                    console.error("Error adding taux fractionnement:", err);
                    toast.error("Erreur lors de l'ajout");
                    setLoading(false);
                });
        }

    };

    const handleCancel = () => {
        setRang(0);
        setTaux(0);
        setLibelle("");
        setIsModalOpen(false);
    }

    useEffect(() => {
        if (props.edit) {
            setRang(props.tauxFractionnement.rang);
            setTaux(props.tauxFractionnement.taux);
            setLibelle(props.tauxFractionnement.libelleTauxFractionnement);
            setEditMode(true);
        }
    }, [props.edit]);

    useEffect(() => {
        setIsModalOpen(props.open);
    }, [props.open]);


    useEffect(() => {
        if (!isModalOpen) {
            props.setOpen(false);
        }
    }, [isModalOpen]);

    return (
        <Modal
            title={editMode ? `Modifier le taux de fractionnement` : `Ajouter un taux de fractionnement`}
            open={isModalOpen}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Annuler
                </Button>,
                <Button key="submit" type="primary" onClick={handleAdd}>
                    Enregistrer
                </Button>,
            ]}
            width={800}
            okText="Enregistrer"
            cancelText="Annuler"
            loading={loading}
        >
            <div className="p-6 row">
                <div className="col-6">
                    <label className="form-label">Rang*</label>
                    <input type="text" className="form-control" placeholder="Le rang" value={rang} onChange={(e) => setRang(e.target.value)} />
                </div>
                <div className="col-6">
                    <label className="form-label">Taux*</label>
                    <input type="text" className="form-control" placeholder="Le taux" value={taux} onChange={(e) => setTaux(e.target.value)} />
                </div>
                <div className="col-12">
                    <label className="form-label">Libellé*</label>
                    <textarea type="text" className="form-control" placeholder="Libellé de la ligne" value={libelle} onChange={(e) => setLibelle(e.target.value)} ></textarea>
                </div>
            </div>
        </Modal>
    )
}

TauxFractionnement.propTypes = {
    open: PropTypes.bool,
    tauxFractionnement: PropTypes.object,
    fractionnement: PropTypes.object,
    edit: PropTypes.bool,
    setOpen: PropTypes.func,
};

export default TauxFractionnement